import { useContext } from 'react';
import { SearchHeadlessContext } from './SearchHeadlessContext';
export function useSearchActions() {
    const searchHeadless = useContext(SearchHeadlessContext);
    if (searchHeadless.state === undefined) {
        throw new Error('Attempted to call useSearchActions() outside of SearchHeadlessProvider.'
            + ' Please ensure that \'useSearchActions()\' is called within an SearchHeadlessProvider component.');
    }
    return searchHeadless;
}
//# sourceMappingURL=useSearchActions.js.map